import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { useCurrency } from '~/shared/hooks';
import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';

type Props = {
    data: ShopTypes.OrderDetailsResponse;
};

export default function OrderDetailsCardBottom({ data }: Props) {
    const { translate } = useTranslations();
    const formatCurrency = useCurrency();

    return (
        <CardBottom>
            <CardBottomItem>
                <span>{translate('mit-fog.orderDetails.subTotal')}</span>
                {formatCurrency(data.subTotal)}
            </CardBottomItem>
            <CardBottomItem bottomBorder>
                <span>{translate('mit-fog.orderDetails.freightTotal')}</span>
                {formatCurrency(data.freightTotal)}
            </CardBottomItem>
            <CardBottomItem isPrice lastItem>
                <span>{translate('mit-fog.orderDetails.total')}</span>
                {formatCurrency(data?.total)}
            </CardBottomItem>
        </CardBottom>
    );
}

const CardBottom = styled.ul(({ theme }) => ({
    background: theme.colors.offWhite,
    padding: theme.space[3],
    listStyle: 'none',
    marginTop: `-${theme.space[3]}`,
}));

export const CardBottomItem = styled.li<{
    bottomBorder?: boolean;
    isPrice?: boolean;
    lastItem?: boolean;
}>(
    ({ theme, isPrice }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        color: theme.colors.nightBlack,
        fontSize: theme.fontSizes.guinea,
        fontWeight: isPrice ? theme.fontWeights.medium : theme.fontWeights.normal,
        fontStyle: 'normal',
        lineHeight: theme.lineHeights.coyote,
        letterSpacing: '-0.108px',
        paddingBottom: theme.space[2],
    }),

    ifProp('bottomBorder', ({ theme }) => ({
        borderBottom: `1px solid ${theme.colors.nightBlack}`,
    })),

    ifProp('lastItem', ({ theme }) => ({
        paddingTop: theme.space[2],
        paddingBottom: 0,
    })),
);
